import React from 'react';


    const containerStyle = {
        maxWidth: '900px',
        margin: '0 auto',
        padding: '20px',
        color: '#333',
        lineHeight: '1.6',
        fontSize: '20px' // Tamaño de fuente 12px para todo el contenido
    };

    const titleStyle = {
        textAlign: 'center',
        fontSize: '25px', // Título ligeramente más grande pero manteniendo proporción
        fontWeight: 'bold',
        marginBottom: '15px',
        paddingBottom: '10px',
    };

    const sectionStyle = {
        marginBottom: '20px',
        padding: '15px',
        borderRadius: '5px',
    };

    const headingStyle = {
        fontWeight: 'bold',
        marginBottom: '10px',
        fontSize: '20px' // Tamaño de fuente 12px para los encabezados
    };

    const listStyle = {
        paddingLeft: '15px',
        marginBottom: '10px'
    };

    const listItemStyle = {
        marginBottom: '6px',
        fontSize: '16px' // Tamaño de fuente 12px para items de lista
    };

    const paragraphStyle = {
        marginBottom: '10px',
        fontSize: '16px' // Tamaño de fuente 12px para párrafos
    };

    const noteStyle = {
        padding: '12px',
        borderRadius: '5px',
        borderLeft: '4px solid #f59e0b',
        marginTop: '20px',
        fontWeight: 'bold',
        color: '#b45309',
        fontSize: '16px', // Tamaño de fuente 12px para la nota
    };

    const contactInfoStyle = {
        color: '#2b6cb0',
        fontWeight: 'bold',
        fontSize: '16px' // Tamaño de fuente 12px para información de contacto
    };
const PoliticsES = () => {
    return (
        <div style={containerStyle}>
            <h1 style={titleStyle}>POLÍTICA Y PROCESO DE DEVOLUCIÓN</h1>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>Objetivo:</h2>
                <p style={paragraphStyle}>
                    Garantizar una experiencia satisfactoria para el cliente al gestionar devoluciones de productos de manera eficiente,
                    rápida y justa, considerando que toda devolución aprobada va de la mano de una previa revisión del producto.
                </p>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>1. Plazo y condiciones Generales de Devolución:</h2>
                <p style={paragraphStyle}>
                    Para que una devolución aplique debe cumplir con los siguientes criterios:
                </p>
                <ul style={listStyle}>
                    <li style={listItemStyle}>La devolución se solicita dentro de los 15 días naturales posteriores a la fecha de entrega del producto.</li>
                    <li style={listItemStyle}>El producto debe estar nuevo, sin usar y no haber sido instalado.</li>
                    <li style={listItemStyle}>El producto debe estar en su empaque original, manuales de uso, etiquetas y accesorios completos.</li>
                    <li style={listItemStyle}>El empaque debe estar en buenas condiciones.</li>
                    <li style={listItemStyle}>En caso de productos defectuosos o dañados, debe presentar evidencia fotográfica.</li>
                    <li style={listItemStyle}>Error de etiquetado o si la descripción no coincide con el producto entregado.</li>
                </ul>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>2. No aplican devoluciones si:</h2>
                <ul style={listStyle}>
                    <li style={listItemStyle}>El producto fue dañado por mal uso o accidente.</li>
                    <li style={listItemStyle}>Si el empaque está maltratado y/o rayado.</li>
                    <li style={listItemStyle}>Si rebasa la fecha de plazo de los 15 días.</li>
                    <li style={listItemStyle}>Sí fue error de selección del cliente.</li>
                    <li style={listItemStyle}>En caso de enviar producto diferente al reportado no procede la devolución.</li>
                </ul>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>3. Como solicitar una devolución:</h2>
                <p style={paragraphStyle}>
                    Envíanos un correo a <span style={contactInfoStyle}>victoria.marin@shimanomexico.com</span> o mensaje por WhatsApp al <span style={contactInfoStyle}>442 582 0239</span> con:
                </p>
                <ul style={listStyle}>
                    <li style={listItemStyle}>Razón Social.</li>
                    <li style={listItemStyle}>Código del producto.</li>
                    <li style={listItemStyle}>Numero de factura.</li>
                    <li style={listItemStyle}>Numero de pedido.</li>
                    <li style={listItemStyle}>Motivo de la devolución</li>
                    <li style={listItemStyle}>Fotografías del producto (si aplica)</li>
                </ul>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>4. Instrucciones para enviar el producto.</h2>
                <p style={paragraphStyle}>
                    Los costos de envió por devolución corren a cargo del cliente, salvo que sea por error de envió, mal etiquetado o producto
                    dañado.
                </p>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>5. Revisión del Producto.</h2>
                <p style={paragraphStyle}>
                    Cuando el producto llegue a planta el equipo de control de calidad lo revisará en un plazo no mayor a 5 días hábiles.
                </p>
                <p style={paragraphStyle}>
                    En caso de ser APROBADA la devolución, se procede con la nota de crédito o cambio de la pieza, según aplique.
                </p>
                <p style={paragraphStyle}>
                    En caso de NO SER APROBADA, se notifica al cliente y se puede ofrecer el reenvío del producto (con o sin costo según la
                    política).
                </p>
            </section>
            
            <div style={noteStyle}>
                NOTA: Recuerda que la devolución se puede evitar si te apoyas de tu asesor o el área de soporte técnico, para un buen
                asesoramiento del producto.
            </div>
        </div>
    );
};

export default PoliticsES;